<template>
  <div v-if="srcCover">
    <img :src="srcCover" :style="getStyle" />
  </div>
  <!-- <div v-else /> -->
</template>

<script>

export default {
  props: {
    url: {type: String},
    width: {type: Number},
    height: {type: Number}
  },
  created () {
  },
  mounted () {
    if (this.url) {
      this.img = this.$el.querySelector('img')
      this.img.onerror = (err) => {
        console.log('size error', err, this.url)
        this.errUrl = 'err'
      }
      if (this.img.complete) {
        console.log('size complete')
        // this.$emit('size complete', this.img.width + ' * ' + this.img.height)
      } else {
        this.img.onload = () => {
          console.log('size onload')
          // this.$emit('size onload', this.img.width + ' * ' + this.img.height)
        }
      }
    }
  },
  data () {
    return {
      img: null,
      errUrl: null
    }
  },
  name: 'Cover',
  computed: {
    srcCover () {
      console.log('srcCover', this.errUrl)
      if (this.errUrl || !this.url) {
        console.log('srcCover check', this.errUrl)
        return ''
      }
      return this.url
    },
    getStyle () {
      var ob = {}
      if (this.width) {
        ob.width = this.width.toString() + 'px'
      }
      if (this.height) {
        ob.height = this.height.toString() + 'px'
      }
      return ob
    }
  },
  methods: {
  },
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/Cover.vue